import { supabase } from '../lib/supabaseClient';

export interface TrabajadorDeMisTiendas {
  id: string;
  first_names: string;
  last_names: string;
  phone: string | null;
}

/**
 * Nombre y teléfono de la gente de las tiendas que supervisa quien pregunta (RPC de la 0218).
 * Para quien no es supervisor la RPC devuelve vacío.
 */
export async function trabajadoresDeMisTiendas(): Promise<Map<string, TrabajadorDeMisTiendas>> {
  const { data, error } = await supabase.rpc('trabajadores_de_mis_tiendas');
  if (error) throw new Error(`No se pudieron cargar los nombres del equipo: ${error.message}`);
  return new Map(((data ?? []) as TrabajadorDeMisTiendas[]).map((t) => [t.id, t]));
}

/**
 * Completa el trabajador de las filas donde el embed de `profiles` llegó en null.
 *
 * El supervisor de ruta NO lee `profiles`: sus columnas tienen permiso para todo `authenticated`
 * (teléfono, dirección, nacimiento, rutas del documento) y abrirle las filas se las daría todas. Por
 * eso, para él, el `worker:profiles!…(…)` embebido llega vacío, y acá se rellena con nombre y teléfono,
 * **sin DNI** (que en este sistema es medio usuario).
 *
 * Solo consulta si falta alguno: para el coordinador y el admin, que sí leen `profiles`, no hay ninguna
 * llamada extra. Muta las filas que recibe, así que va ANTES de transformarlas. Cada fila necesita traer
 * `worker_id`: sin él no hay a quién buscar y queda como estaba.
 */
export async function completarTrabajadores(
  filas: ReadonlyArray<{ worker_id?: string | null; worker?: unknown }>,
): Promise<void> {
  const huecos = filas.filter((f) => (f.worker === null || f.worker === undefined) && f.worker_id);
  if (huecos.length === 0) return;
  const mapa = await trabajadoresDeMisTiendas();
  for (const f of huecos) {
    const t = mapa.get(f.worker_id as string);
    if (t) {
      (f as { worker: unknown }).worker = {
        id: t.id, dni: '', first_names: t.first_names, last_names: t.last_names, phone: t.phone,
      };
    }
  }
}
